import React, { Component } from 'react';
import * as GlobalActions from '../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SelectionCard from '../LandingPageNew/LandingSubComponents/SelectionCard';
import view, { validation, borders, propertyType } from '../../Enums';
import DropdownMenuLocation from '../../common/DropDownLocation';
import * as IMAGES from '../../Images';
import DropdownMenuMobile from '../../common/DropdownMenMobileu';
import allCountriesData from '../../utils/country-code-mapping';
import { NavLink } from 'react-router-dom';
import { Event } from '../LandingPageNew/Tracking/Track';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

//TODO: position: fixed for form 1 if height >=668px
class FormOne extends Component {
  constructor(props) {
    super(props);
    this.changeMobile = this.changeMobile.bind(this);
    this.flag = this.flag.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  state = {
    showDropdown: false,
    dropDownOptions: [],
    selectedLocation: null,
    dialCode: '+91',
    flagPos: 1360,
    showDropdownMobile: false,
    debounceTimer: null,
    nameBorder: borders.NORMAL_BORDER,
    mobileBorder: borders.NORMAL_BORDER,
    locationBorder: borders.NORMAL_BORDER,
    location_error:''
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.globalData.locationData.isFetching &&
      !this.props.globalData.locationData.isFetching &&
      this.props.globalData.location
    ) {
      if (
        this.props.globalData.locationData.location.responseObject &&
        this.props.globalData.locationData.location.responseObject.length
      ) {
        this.setState({
          showDropdown: true,
          dropDownOptions: this.props.globalData.locationData.location
            .responseObject
        });
      } else {
        this.setState({
          showDropdown: true,
          dropDownOptions: [{
            type : 'error',
            displayName: 'Can\'t find relevant results, try retyping'
          }]
        });
      }
    }
  }

  componentDidMount() {
    Event('Partner Page Step 1 form', 'Step 1 form page viewed', '', '');

    this.flagAndDialCode(this.props.globalData.locale.toUpperCase());
    window.onclick = e => {
      this.setState({ showDropdown: false });
    };
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ showDropdownMobile: false });
    }
  }

  flagAndDialCode(country_iso_code) {
    let dialCode = allCountriesData[country_iso_code][0];
    let flagPos = (allCountriesData[country_iso_code][1] - 1) * 16;
    this.props.globalActions.dataUpdate('dial_code', dialCode);
    this.props.globalActions.dataUpdate('flagPos', flagPos);
    this.setState({ flagPos: flagPos });
  }

  changeMobile() {
    let showDropdownMobile = this.state.showDropdownMobile;
    this.setState({ showDropdowobile: !showDropdownMobile });
  }

  flag(country_iso_code) {
    let dialCode = allCountriesData[country_iso_code][0];
    let flagPos = (allCountriesData[country_iso_code][1] - 1) * 16;
    this.props.globalActions.dataUpdate('dial_code', dialCode);
    this.setState(
      { dialCode: dialCode, flagPos: flagPos },
      this.changeMobile()
    );
  }

  onClickDropdown = locationObject => {
    this.props.validate(locationObject, validation.LOCATION);
    this.props.globalActions.updateLocation(locationObject.displayName);
    if (locationObject.city)
      this.props.globalActions.dataUpdate('city', locationObject.city.name);
    if (locationObject.country)
      this.props.globalActions.dataUpdate(
        'country',
        locationObject.country.name
      );
    this.props.globalActions.updateLocationObject(locationObject);
    // this.props.globalActions.dataUpdate('selected_location', locationObject);
    this.setState({
      showDropdown: false,
      dropDownOptions: [],
      selectedLocation: locationObject,
      location_error: ''
    });
  };

  onLocationTextUpdate = e => {
    Event(
      'Partner Page Step 1 form',
      'Location selected on step 1 form page',
      '',
      ''
    );
    const { updateLocationtext = () => {} } = this.props;
    let query = e.target.value;
    this.onClickDropdown('');
    this.setState({selectedLocation : null , location_error : ''});
    this.props.globalActions.updateLocation(query);
    updateLocationtext(query);
    if (this.state.debounceTimer) clearTimeout(this.state.debounceTimer);
    if (query) {
      this.setState({
        debounceTimer: setTimeout(() => this.getLocationSuggestions(query), 200)
      });
    } else {
      this.setState({ showDropdown: false });
    }
  };

  getLocationSuggestions = query => {
    let regionCode =
        allCountriesData[this.props.globalData.locale.toUpperCase()][3];
    this.props.globalActions.fetchLocationSearch(query, regionCode);
  };
  changeMobile = () => {
    let showDropdownMobile = this.state.showDropdownMobile;
    this.setState({ showDropdownMobile: !showDropdownMobile });
  };
  
  handleClickAway = () =>{
    let location_error = '';
    if(!this.state.selectedLocation && this.props.globalData.location)
      location_error = this.props.getUniversalContent('location_error') ;
    
    this.setState({ showDropdown  : false , location_error : location_error });
  }

  render() {
    let gc = this.props.getContent;
    let guc = this.props.getUniversalContent;
    let gs = this.props.getStyle;
    let gi = this.props.getImage;
    let abc = false;
    return (
      <React.Fragment>
        {this.props.globalData.form_translations && (
          <div
            style={{
              height: this.props.screenheight - 80 + 'px',
              overflowY:
                this.props.viewMode == view.MOBILE ? 'scroll' : 'scroll'
            }}
          >
            <div>
              {this.props.viewMode == view.DESKTOP && (
                <NavLink
                  exact
                  to={
                    this.props.globalData.locale
                      ? '/' + this.props.globalData.locale
                      : '/'
                  }
                  style={{ textDecoration: 'none', color: '#ffffff' }}
                >
                  <img src={gi('OYO_WHITE')} style={gs('form1_icon')} />
                </NavLink>
              )}

              <div style={gs('text_div_form_one')}>
                <span style={gs('form1_step_one_text')}>{gc('step_1')}</span>
                <span style={gs('form1_step_two_text')}>
                  {' ' + gc('of_2')}
                </span>

                <div style={gs('lets_start_contact')}>
                  {gc('lets_start_contact')}
                </div>
                <div style={gs('all_communications_with')}>
                  {gc('all_communications_with')}
                </div>
              </div>

              <div style={gs('form1_input_parent')}>
                <div style={gs('input_label_form')}>{gc('formstep1_name')}</div>
                <input
                  className="hideArrow mobile"
                  style={{
                    ...gs('form1_input'),
                    marginBottom:'30px',
                    border: this.props.stepOneBorderNameValidated
                      ? this.state.nameBorder
                      : borders.RED_BORDER
                    // border: this.props.stepOneBorderNameValidated
                    //   ? (abc ?borders.ACTIVE_BORDER:borders.NORMAL_BORDER)
                    //   : borders.RED_BORDER,
                    // border:abc?borders.ACTIVE_BORDER:borders.NORMAL_BORDER
                  }}
                  onFocus={event => {
                    this.setState({
                      nameBorder: borders.ACTIVE_BORDER
                    });
                    // style['border']=borders.ACTIVE_BORDER

                    // this.getStyle({border:borders.ACTIVE_BORDER})

                    // border: this.props.stepOneBorderNameValidated
                    //     ? borders.ACTIVE_BORDER
                    //     : borders.RED_BORDER
                  }}
                  onBlur={event => {
                    this.setState({
                      nameBorder: borders.NORMAL_BORDER
                    });
                  }}
                  placeholder={gc('name_placeholder')}
                  type="text"
                  required
                  autoComplete="new-password"
                  value={
                    this.props.globalData.formData
                      ? this.props.globalData.formData.full_name
                      : ''
                  }
                  onChange={e => {
                    this.props.validate(e.target.value, validation.FULL_NAME);
                    this.props.globalActions.dataUpdate(
                      'full_name',
                      e.target.value
                    );
                    Event(
                      'Partner Page Step 1 form',
                      'Name entered on step 1 form page',
                      '',
                      ''
                    );
                  }}
                />
              </div>

              <div style={gs('form1_input_parent')}>
                <div style={gs('input_label_form')}>
                  {gc('formstep1_location')}
                </div>
                <input
                  className="hideArrow mobile"
                  style={{
                    ...gs('form1_input'),
                    marginBottom:'10px',
                    border: this.props.stepOneBorderLocation
                      ? this.state.locationBorder
                      : borders.RED_BORDER
                  }}
                  placeholder={gc('location_placeholder')}
                  type="text"
                  required
                  autoComplete="new-password"
                  value={
                    this.props.globalData ? this.props.globalData.location : ''
                  }
                  onChange={this.onLocationTextUpdate}
                  onFocus={event => {
                    // event.target.style.border = borders.ACTIVE_BORDER;
                    this.setState({ locationBorder: borders.ACTIVE_BORDER });
                  }}
                  onBlur={event => {
                    // event.target.style.border = borders.NORMAL_BORDER;
                    this.setState({ locationBorder: borders.NORMAL_BORDER });
                  }}
                />
                <ClickAwayListener
                    onClickAway={this.handleClickAway}
                >
                  <div>
                {this.state.showDropdown && (
                  <DropdownMenuLocation
                    width={
                      this.props.viewMode == view.DESKTOP ? '404px' : '98.5%'
                    }
                    top={'73px'}
                    options={this.state.dropDownOptions}
                    style={{ zIndex: '3' }}
                    change={this.onClickDropdown}
                  />
                )}
                  </div>
                </ClickAwayListener>
              </div>
               <div
                  style={{
                    ...gs('form_small_text'),
                    color: 'red',
                    lineHeight: '1.1',
                    height: '20px'
                  }}
              >
                {this.state.location_error}
              </div>

              <div style={gs('form1_input_parent')}>
                <div style={gs('input_label_form')}>
                  {gc('formstep1_number')}
                </div>

                <div
                  style={{
                    ...gs('phone_number_parent_f1'),
                    border: this.props.stepOneBorderPhoneNumber
                      ? this.state.mobileBorder
                      : borders.RED_BORDER
                  }}
                  ref={this.setWrapperRef}
                >
                  <span
                    onClick={this.props.changeMobile}
                    style={{ ...gs('flag_parent_span') }}
                  >
                    <img
                      src={IMAGES.DOWN_ARROW}
                      alt="open dropdown"
                      className="hover"
                      style={{
                        marginLeft: '10px',
                        position: 'relative',
                        top: '1px'
                      }}
                      onClick={this.changeMobile}
                    />
                    <span
                      style={{
                        ...gs('flagImage'),
                        backgroundPosition: '0 -' + this.state.flagPos + 'px'
                      }}
                    />
                    <span style={{ ...gs('dial_Code') }}>
                      {this.props.globalData.formData.dial_code}
                    </span>
                    <input
                      className="hideArrow mobile"
                      style={{ ...gs('ph_number_input') }}
                      placeholder={gc('mobile_number_placeholder')}
                      type="text"
                      required
                      autoComplete="new-password"
                      value={
                        this.props.globalData.formData
                          ? this.props.globalData.formData.mobile_number
                          : ''
                      }
                      onChange={e => {
                        Event(
                          'Partner Page Step 1 form',
                          'Mobile number entered on step 1 form page',
                          '',
                          ''
                        );
                        if (
                          !isNaN(e.target.value) &&
                          !e.target.value.includes('.')
                        ) {
                          this.props.validate(
                            e.target.value,
                            validation.PHONE_NUMBER
                          );
                          this.props.globalActions.dataUpdate(
                            'mobile_number',
                            e.target.value
                          );
                        }
                      }}
                      onFocus={event => {
                        this.setState({
                          mobileBorder: borders.ACTIVE_BORDER
                        });
                      }}
                      onBlur={event => {
                        this.setState({
                          mobileBorder: borders.NORMAL_BORDER
                        });
                      }}
                    />
                  </span>

                  {this.state.showDropdownMobile && (
                    <DropdownMenuMobile
                      viewMode={this.props.viewMode}
                      k={this.flag}
                      divWidth={'404px'}
                    />
                  )}
                </div>
              </div>
              <div style={gs('type_of_property_parent')}>
                <div style={gs('input_label_form')}>
                  {gc('formstep1_typeOfProperty')}
                </div>

                <div style={gs('type_of_property_flex_parent')}>
                  <SelectionCard
                    width={'48%'}
                    height={'56px'}
                    viewMode={this.props.viewMode}
                    selected={
                      this.props.globalData.type_of_property ===
                      propertyType.HOTEL
                    }
                    info_icon={gi('info_icon')}
                    type_icon={gi('hotel_icon')}
                    tick={gi('green_tick')}
                    type_text={gc('Hotel')}
                    type_style_tag={'hotel_icon'}
                    onClick={() => {
                      this.props.globalActions.updatePropertyType(
                        propertyType.HOTEL
                      );
                      Event(
                        'Partner Page Step 1 form',
                        'Property type selected on step 1 form page',
                        'Hotel',
                        ''
                      );
                    }}
                  />

                  <SelectionCard
                    width={'48%'}
                    height={'56px'}
                    viewMode={this.props.viewMode}
                    selected={
                      this.props.globalData.type_of_property ===
                      propertyType.HOME
                    }
                    info_icon={gi('info_icon')}
                    type_icon={gi('house_icon')}
                    tick={gi('green_tick')}
                    type_text={gc('Home')}
                    type_style_tag={'house_icon'}
                    onClick={() => {
                      this.props.globalActions.updatePropertyType(
                        propertyType.HOME
                      );
                      Event(
                        'Partner Page Step 1 form',
                        'Property type selected on step 1 form page',
                        'Home',
                        ''
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            <div style={gs('button_parent_form')}>
              {this.props.viewMode == view.DESKTOP && (
                <NavLink
                  onClick={() => {
                    Event(
                      'Partner Page Step 1 form',
                      'Back button clicked on Step 1 form page',
                      'Home',
                      ''
                    );
                  }}
                  exact
                  style={gs('button_left_form')}
                  to={
                    this.props.globalData.locale
                      ? '/' + this.props.globalData.locale
                      : '/'
                  }
                >
                  <div className={'hover'}>
                    <span style={gs('button_left_form_text')}>
                      <img
                        style={{
                          position: 'relative',
                          top: '2px',
                          marginRight: '8px'
                        }}
                        src={gi('gray_arrow_left')}
                      />
                      {guc('back')}
                    </span>
                    {/*</NavLink>*/}
                  </div>
                </NavLink>
              )}

              <div
                onClick={() => {
                  this.props.validateCurrentForm();
                }}
                style={gs('button_right_form')}
                className={'hoverColor'}
              >
                <span style={gs('button_right_form_text')}>
                  {guc('next')}
                  {this.props.viewMode == view.DESKTOP && (
                    <img
                      style={{
                        marginLeft: '8px',
                        position: 'relative',
                        top: '2px'
                      }}
                      src={gi('white_arrow_right')}
                    />
                  )}
                </span>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormOne);
